import React from 'react';
import { useIntl } from 'react-intl';
import { Text } from 'components/typography';
import { Grid } from 'components/layout/Grid';
import styles from './styles.module.scss';
import { ManagePrimaryResidentPermissions } from './components/ManagePrimaryResidentPermissions';
import { Manage2nPermissions } from './components/Manage2nPermissions';

export function ManageAccessToServices() {
  const intl = useIntl();

  return (
    <Grid
      noPadding
      oneColumn
      className={styles.servicesContainer}
      justifyItems="start"
    >
      <Text
        size={20}
        fontWeight={700}
      >
        {intl.formatMessage({ id: 'accessToServices' })}
      </Text>

      <div className={styles.services}>
        
        <ManagePrimaryResidentPermissions />

        <Manage2nPermissions />

      </div>
    </Grid>
  );
}
